// extracted by mini-css-extract-plugin
export default {"gridContainer":"galleryVideos_gridContainer__Waqp7","wrapperVideo":"galleryVideos_wrapperVideo__aRVjo","videoMain":"galleryVideos_videoMain__A1iyA"};